module.exports = __webpack_public_path__ + "static/img/navbar_8.bfe00ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_8.png
// module id = CbCi
// module chunks = 25